const initialState = {
  auth: {
    status: 'ANONYMOUS',
    email: null,
    displayName: null,
    uid: null,
    signedCampaignId: null,
    createdCampaignId: null,
    loading: false
  }
};

export default initialState;



// WEBPACK FOOTER //
// ./src/redux/initial-state.js